import * as React from "react";

import type { IIconProps } from "@fluentui/react/lib/Icon";
import { Icon } from "@fluentui/react/lib/Icon";

import { getLargeControlText } from "./largeControlTextUtils";
import { AppIcon } from "@1js/acui-icons";
import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

export const renderMLRLargeMenuAnchorText = (
  text: string,
  menuIconProps: IIconProps,
  disabled: boolean | undefined,
  containerClassName: string,
  line2ClassName: string,
  iconClassName: string
): JSX.Element => {
  const { line1, line2 } = getLargeControlText(text);

  return (
    <AppContext.Consumer>
      {(context) => {
        const isV9IconEnabled = !!checkExperiment(
          context,
          ribbonExperiments.fluentV9IconIsEnabled
        );

        return (
          <div className={containerClassName}>
            {line1}
            <div className={line2ClassName}>
              {line2}
              {isV9IconEnabled ? (
                <AppIcon
                  {...menuIconProps}
                  className={iconClassName}
                  style={
                    !!disabled
                      ? (disabledIconStyle as React.CSSProperties)
                      : undefined
                  }
                />
              ) : (
                <Icon
                  {...menuIconProps}
                  className={iconClassName}
                  style={!!disabled ? disabledIconStyle : undefined}
                />
              )}
            </div>
          </div>
        );
      }}
    </AppContext.Consumer>
  );
};

/**
 * This represents the style for the disabled icon.
 */
const disabledIconStyle = {
  opacity: 0.4,
};
